module.exports = __webpack_public_path__ + "img/account-switch.d1cfa902.svg";